import { DataProxy, FetchResult, MaybeMasked } from '@apollo/client'
import {
  OneOffPaymentInput,
  OneOffPayment,
  CreateOrUpdateOneOffPaymentMutation,
  CreateOrUpdateOneOffPaymentMutationVariables,
  DeleteOneOffPaymentMutation,
} from '../../types'
import { client } from '../..'
import OneOffPaymentMutations from './OneOffPaymentMutations'
import { FIND_ONE_OFF_PAYMENTS_BY_MEETING_ID } from './OneOffPaymentQueries'

const transformToInput = (oneOffPayment: OneOffPayment | null): OneOffPaymentInput => {
  if (oneOffPayment) {
    return oneOffPayment as OneOffPaymentInput
  } else {
    // to do magic for payment date
    return {
      comment: '',
      resultAmount: 0,
      paymentDate: new Date().toISOString(),
    } as OneOffPaymentInput
  }
}
const transformToObject = (oneOffPayment: OneOffPaymentInput): OneOffPayment => {
  const ret = {
    id: oneOffPayment.id ? oneOffPayment.id : -1,
    comment: oneOffPayment.comment,
    paymentDate: oneOffPayment.paymentDate,
    resultAmount: oneOffPayment.resultAmount ? oneOffPayment.resultAmount : 0,
  } as OneOffPayment
  return ret
}

const mutateCreateOrUpdateOneOffPayment = (
  oneOffPaymentInput: OneOffPaymentInput,
  meetingId: number,
): Promise<FetchResult<MaybeMasked<CreateOrUpdateOneOffPaymentMutation>>> => {
  return client.mutate<CreateOrUpdateOneOffPaymentMutation, CreateOrUpdateOneOffPaymentMutationVariables>({
    mutation: OneOffPaymentMutations.CreateOrUpdateOneOffPayment,
    variables: {
      oneOffPayment: oneOffPaymentInput,
    },
    update: (store: DataProxy, { data }) => {
      if (!data || !data.createOrUpdateOneOffPayment) {
        return
      }

      // Write our data back to the cache
      store.writeQuery<{ oneOffPaymentByMeetingId: OneOffPayment }>({
        query: FIND_ONE_OFF_PAYMENTS_BY_MEETING_ID,
        variables: { meetingId: meetingId },
        data: { oneOffPaymentByMeetingId: data.createOrUpdateOneOffPayment },
      })
    },
  })
}
const mutateDeleteOneOffPayment = (
  oneOffPaymentId: number,
  meetingId: number,
): Promise<FetchResult<MaybeMasked<DeleteOneOffPaymentMutation>>> => {
  return client.mutate({
    mutation: OneOffPaymentMutations.DeleteOneOffPayment,
    variables: {
      oneOffPaymentId: oneOffPaymentId,
    },
    update: (store: DataProxy) => {
      // Write our data back to the cache
      store.writeQuery<{ oneOffPaymentByMeetingId: null }>({
        query: FIND_ONE_OFF_PAYMENTS_BY_MEETING_ID,
        variables: { meetingId: meetingId },
        data: { oneOffPaymentByMeetingId: null },
      })
    },
  })
}

export default {
  mutateCreateOrUpdateOneOffPayment,
  mutateDeleteOneOffPayment,
  transformToInput,
  transformToObject,
}
